import React from 'react';

const InputField = ({ label, name, value, type = 'text', required = false, handleChange, errors={} }) => {
 
    return (
        <div className="space-y-1">
      <label className="text-sm font-medium text-gray-700 flex items-center gap-1">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 ${
          errors[name] ? 'border-red-500' : 'border-gray-200'
        }`}
      />
    </div>
    )
}

export default InputField;
